import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import alert from '@/pages/components/common/alert';
import './scss/bind_phone.scss'

interface initProps {
	history: any,
}

class BindPhone extends React.Component <initProps, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			imgCode: '',
			form: {
				username: '',
				code: '',
			},
			captchakey: '',  // 验证码随机数
			captchaUrl: '',  // 图形验证码地址
			timer: '', // 定时器	
			timerNumber: 60, //
			isOpenTimer: false,
			isSubmit: false,
		};
	}

	componentDidMount() {
		this.getGraphic();
	}

	render() {
		return (
			<div className="page-bindPhone">
				<h2 className="bindPhone-title">尊敬的用户，买化塑欢迎您!</h2>
				<p className="bindPhone-prompt">为了您的账号安全，请先绑定手机号码，后续可使用该手机号码进行登录</p>
				<div className="form">
					<input type="text"  placeholder="请输入手机号" className="login-input" value={this.state.form.username} onChange={ (e:any) => this.setForm('username', e.target.value) } />
					{/*<div className="code-warpper">
						<input type="text"   placeholder="请输入图形验证码" value={this.state.imgCode} onChange={ (e:any) => this.setState({ imgCode: e.target.value }) }   className="login-input" />
						<img src={this.state.captchaUrl} alt="" className="code-img" onClick={() => this.getGraphic()}/>
					</div>
					<div className="code-warpper">
						<input type="text"   placeholder="请输入验证码" className="login-input" value={this.state.form.code}  onChange={ (e:any) => this.setForm('code', e.target.value) } />
						<button type="button" className="code-btn" onClick={() => this.sendMessage()}>{this.state.timerNumber === 60 ? '获取验证码' : this.state.timerNumber}</button>
					</div>*/}
				
					<button className="submit-btn"  onClick={() => this.submitForm()}>立即绑定</button>
				</div>
				<p className="bottom-prompt">点击绑定代表您已阅读
					<a href="//www.ibuychem.com/legalnotice.html" className="link">《买化塑用户服务协议》</a>
					和
					<a href="//www.hzeyun.com/legalnotice.html" className="link">《慧正资讯法律声明》</a>
				</p>
			</div>
		)
	}

	private getOuthBackUrl() {
		const returnUrl = GetQueryString('returnUrl');
		function GetQueryString(name: any)
		{
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  r[2] ; return null;
		}

		if(returnUrl) {
			return returnUrl
		}else {
			return encodeURIComponent(encodeURIComponent(window.location.origin + '/mobile/uc/build'))
		}
	}

	// 获取验证码
	private getGraphic() {
		const text = Math.random() * Math.pow(10,17);
		const url = config.WAPAPI + 'captcha/image?captchakey=' + text;

		this.setState({
			captchaUrl: url,
			captchakey: text,
		})
	}

	// 表单赋值
	private setForm(name?: string, val?: any) {

		if(!name) {
			return ;
		}
		this.state.form[name] = val;
		this.setState({
			form: { 
				...this.state.form,
			} 
		})
	}

	// 发送短信
	// private sendMessage() {
	// 	const that = this;
	// 	if (this.state.isOpenTimer) {
	// 		return;
	// 	}
	// 	if (this.state.form.username.replace(/\s/gi, '') === '') {
	// 		alert.open({
	// 			promptText: '请输入手机号',
	// 		})
	// 		return;
	// 	}
	// 	if (this.state.imgCode.replace(/\s/gi, '') === '') {
	// 		alert.open({
	// 			promptText: '请输入图形验证码',
	// 		})
	// 		return;
	// 	}

	// 	this.setState({
	// 		isOpenTimer: true,
	// 	}, () => {
	// 		const data = request({
	// 			method: "get",
	// 			url: `${config.API2}sms/send`,
	// 			data: {
	// 				type: 3,
	// 				mobile: this.state.form.username,
	// 				captchakey: this.state.captchakey,
	// 				imgCode: this.state.imgCode,
	// 			}
	// 		});

	// 		data.then(r => {
	// 			if (r.code === 1) {
	// 				// 如果成功 开启定时器
	// 				that.setState({
	// 					timer: setInterval(() => {
	// 						if (that.state.timerNumber > 0) {
	// 							that.setState({
	// 								timerNumber: this.state.timerNumber - 1,
	// 							})
	// 						} else {
	// 							//  重置定时器
	// 							clearInterval(this.state.timer);
	// 							that.getGraphic();
	// 							that.setState({
	// 								isOpenTimer: false,
	// 								timer: '',
	// 								timerNumber: 60,
	// 							})
	// 						}
	// 					}, 1000)
	// 				})


	// 			} else {
	// 				that.getGraphic();
	// 				that.setState({
	// 					isOpenTimer: false,
	// 				}, () => {
	// 					alert.open({
	// 						promptText: r.msg,
	// 					})
	// 				})
	// 			}
	// 		})

	// 	})

		
	// }

	// 检查表单
	private checkForm() {
		// if(this.state.form.code.replace(/\s/gi, '') === '') {
		// 	alert.open({
		// 		promptText: '请输入验证码',
		// 	})

		// 	return ;
		// }
		if(this.state.form.username.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入手机号',
			})
			return ;
		}
		return true;
	}

	// 提交表单
	private async submitForm() {
		const that = this;
		const type = GetQueryString('type');
        function GetQueryString(name: any) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        }

		if (!this.state.isSubmit) {
			if (!this.checkForm()) {
				return;
			}
			// 防止重复提交
			this.setState({
				isSubmit: true,
			})
			// 检查手机
			const r = await request({
				method: "get",
				url: `${config.WAPAPI}security/checkMobileReg`,
				data: {
					mobile: this.state.form.username,
					type: type,
				}
			});

			if (r.code !== 1) {
				that.setState({
					isSubmit: false,
				}, () => {
					alert.open({
						promptText: r.msg,
					})
				})
				
			} else {
				// 绑定手机号
				const r2 = request({
					method: "post",
					url: `${config.WAPAPI}bindMobile`,
					data: {
						mobile: this.state.form.username,
						type: type,
						// smsCode: this.state.form.code,
					}
				});
				r2.then(res => {
					that.setState({
						isSubmit: false,
					}, () => {
						if(res.code === 1) {
							that.setState({
								form: {
									username: '',
									code: '',
								}
							}, () => {
								window.location.href = decodeURIComponent(decodeURIComponent(that.getOuthBackUrl()));
							})
						}else {
							alert.open({
								promptText: res.msg,
							})
						}
					})
				})
			}
		}
	}
}

export default BindPhone;